import {Directive, ElementRef, Input, OnInit} from '@angular/core';
import { ResourceService } from 'src/app/services/resource/resource.service';

@Directive({
    selector: '[lg-path], [lg-key]'
})
export class ResourceLanguageDirective implements OnInit {
    @Input('lg-path') lgPath?: string = '';
    @Input('lg-key') lgKey?: string = '';
    @Input('lg-default') lgDefault?: string = '';

    constructor(
        private resourceService: ResourceService,
        private elem: ElementRef
    ) {}

    ngOnInit(): void {
        const text = this.resourceService.getCachedData(this.lgPath, this.lgKey) ?? this.lgDefault;
        this.elem.nativeElement.innerText = text;
    }
}